import { Stack, Typography, Button } from '@mui/material'
import useIsSuperUserVisible from '@/services/hooks/useIsSuperUserVisible'
import { useDemoModeContext } from '@/components/demo-mode-provider/DemoModeProvider'

export default function DemoModeInfo() {
  const isSuperUserVisible = useIsSuperUserVisible()
  const [, setDemoMode] = useDemoModeContext()
  const isProd = import.meta.env.VITE_ENVIRONMENT === 'prod'

  return !isProd || isSuperUserVisible ? (
    <Stack
      direction="row"
      alignItems="center"
      spacing={0.5}
      sx={{
        border: (theme) => `1px solid ${theme.palette.secondary.main}`,
        borderRadius: '4px',
        px: 1,
      }}
    >
      {!isProd && (
        <Typography
          sx={{ textTransform: 'uppercase', fontSize: '13px' }}
          color="neutral"
        >
          {import.meta.env.VITE_ENVIRONMENT}
        </Typography>
      )}
      {isSuperUserVisible && (
        <>
          {!isProd && (
            <Typography sx={{ pl: 0.75 }} color="neutral">
              •
            </Typography>
          )}
          <Button onClick={() => setDemoMode(true)} variant="text">
            Turn On Demo Mode
          </Button>
        </>
      )}
    </Stack>
  ) : null
}
